import { atom } from 'recoil';

/**
 * Whether the table of content is opened or not on small screens.
 */
export const isTableOfContentOpenedOnMobileAtom = atom<boolean>({
    key: 'isTableOfContentOpenedOnMobileAtom',
    default: false,
});
